import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { UserDm } from "@/_models";
import {
    AuthenticationService,
    USER_IS_AT_LEAST_ADMIN,
    USER_IS_OWNER,
    UserService,
} from "@/_services";
import { MenuSection } from "@/_models/menu-item";
import { isAsapAccount } from "@/_models/account.interface";
import { shareReplay, map } from "rxjs/operators";
import { Observable, combineLatest } from "rxjs";
import { MenuService } from "@/_services/menu.service";
import UserModel = UserDm.UserModel;
import { OnboardingGuideService } from "@/_services/onboarding-guide.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "app-desktop-menu",
    templateUrl: "./desktop-menu.component.html",
    styleUrls: ["./desktop-menu.component.scss"],
})
export class DesktopMenuComponent implements OnInit {
    showForms = true;
    hasLinkedLogins = false;
    isAsap = false;
    showOnboardingButton = false;

    @Output() enterEdit: EventEmitter<void> = new EventEmitter<void>();
    @Input() showAccountLink = false;

    asapFormId$: Observable<string | null>;
    currentUser$: Observable<UserModel>;
    mainMenu$: Observable<MenuSection>;
    formMenu$: Observable<MenuSection>;

    constructor(
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private menuService: MenuService,
        private onboardingGuideService: OnboardingGuideService,
        @Inject(USER_IS_OWNER)
        public isOwner$: Observable<boolean>,
        @Inject(USER_IS_AT_LEAST_ADMIN)
        public isAtLeastAdmin$: Observable<boolean>,
    ) {
        this.hasLinkedLogins = this.authenticationService.hasLinkedLogins();
    }

    ngOnInit() {
        this.currentUser$ = this.userService
            .getCurrentUserAsync()
            .pipe(shareReplay());

        combineLatest([this.currentUser$, this.isAtLeastAdmin$])
            .pipe(untilDestroyed(this))
            .subscribe(([user, isAdmin]) => {
                this.isAsap = isAsapAccount(user.account);
                const dismissed = user?.dismissedBanners || [];

                const bannerKey = "onboardingGuide";
                const hasNotDismissed = !dismissed.includes(bannerKey);

                this.showOnboardingButton = isAdmin && hasNotDismissed;

                if (this.showOnboardingButton) {
                    const steps =
                        this.onboardingGuideService.getStepsSnapshot();
                    if (steps.length === 0) {
                        this.onboardingGuideService.refresh().subscribe();
                    }
                }
            });
        this.mainMenu$ = this.menuService.createDesktopMenu();
        this.formMenu$ = this.menuService.createFormMenu();

        this.asapFormId$ = this.onboardingGuideService.asapFormId$;
    }

    toggleCollapse() {
        this.showForms = !this.showForms;
    }

    onOnboardingDismiss() {
        this.showOnboardingButton = false;
    }
}
